module.exports = __webpack_public_path__ + "static/media/xlxthumb.57ccf399.png";